import createTwStyle from '../util/createTwStyle';
import { CHECKBOX_RADIO_SIZE } from './constant';
import type { VBaseCheckboxRadioProps } from './type';

const twStyle = createTwStyle<VBaseCheckboxRadioProps>();

export default twStyle({
  label: ({ disabled, size }) => [
    {
      'cursor-pointer': !disabled,
      'cursor-not-allowed text-gray-400': disabled,
      'text-body-s': size === CHECKBOX_RADIO_SIZE.SM,
      'text-body-m': size === CHECKBOX_RADIO_SIZE.MD,
      'text-body-l': size === CHECKBOX_RADIO_SIZE.LG,
    },
  ],
});
